import React from "react"
import PropTypes from "prop-types"
import AvgIcon from "./AvgIcon"
import GrdIcon from "./GrdIcon"
import CohIcon from "./CohIcon"
import ImpIcon from "./ImpIcon"

const MetricIcon = ({ metricId, ...props }) => {
  switch (metricId) {
    case "avg":
      return <AvgIcon {...props} />
    case "grd":
      return <GrdIcon {...props} />
    case "coh":
      return <CohIcon {...props} />
    case "imp":
      return <ImpIcon {...props} />
    default:
      return null
  }
}

MetricIcon.propTypes = {
  /** The metric identifier for the icon */
  metricId: PropTypes.string,
}
MetricIcon.defaultProps = {
  metricId: "avg",
}

export default MetricIcon
